import styled, { css } from 'styled-components';

import { colorScheme } from '../../theme';

export const Card = styled.div<{ noPadding?: boolean; clip?: boolean; clickable?: boolean }>`
  border-radius: 6px;
  box-shadow: 0 1px 2px 1px rgba(53, 54, 56, 0.08);
  background-color: ${colorScheme.card.background};
  padding: 1em 2em;
  margin-bottom: 1em;
  ${({ noPadding }) => noPadding && 'padding: 0;'}
  ${({ clickable }) => clickable && 'cursor: pointer;'}
  ${({ clip }) =>
    clip &&
    css`
      overflow: hidden;

      .mapboxgl-canvas {
        border-radius: 6px;
        overflow: hidden;
      }
    `}
`;
